import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';

import { FattorinoStats, Offer, Rettifica } from '../models/offer.model';
import { Search } from '../models/search.model';
import { BaseService } from './base.service';

export class OfferService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	linkDeliveryOffers(idfattorino: number, search: Search): Promise<any> {
		return this.http.post(`/ws/offer/${idfattorino}/link`, classToPlain(search));
	}

	setEsito(idofferta: number, esito: string): Promise<Offer> {
		return this.mapResponse<Offer>(this.http.get(`/ws/offer/${idofferta}/${esito}`));
	}

	setNonConsegnato(idofferta: number): Promise<Offer> {
		return this.mapResponse<Offer>(this.http.post(`/ws/offer/nonconsegnata/${idofferta}`, {}));
	}

	acceptAll(esito: string, idfattorino: number): Promise<Offer> {
		return this.mapResponse<Offer>(this.http.post(`/ws/offer/${esito}/delivery/${idfattorino}`, {}));
	}

	printEnvelopes(ids: number[]): Promise<any> {
		return this.mapResponse(this.http.post('/ws/offer/stampa/buste', ids, { responseType: 'blob' }));
	}

	printPresaincarico(fattorinoId: number): Promise<any> {
		return this.mapResponse(this.http.get(`/ws/offer/stampa/presaincarico/${fattorinoId}`, { responseType: 'blob' }));
	}

	printBollettino(ids: number[]): Promise<any> {
		return this.mapResponse(this.http.post('/ws/offer/stampa/bollettini', ids, { responseType: 'blob' }));
	}

	printIncassoFattorino(id: number): Promise<any> {
		return this.mapResponse(this.http.get(`/ws/offer/ristampa/offerteprese/${id}`, { responseType: 'blob' }));
	}

	printRimborsoFattorino(id: number): Promise<any> {
		return this.mapResponse(this.http.get(`/ws/offer/ristampa/offertepagate/${id}`, { responseType: 'blob' }));
	}

	printIncasso(ids: number[]): Promise<any> {
		return this.mapResponse(this.http.post('/ws/offer/ristampa/offerteprese', ids, { responseType: 'blob' }));
	}

	printStatsFattorini(hid: number, start: number, stop: number): Promise<any> {
		return this.mapResponse(this.http.get(`/ws/offer/stampa/statsfattorini/${hid}/${start}/${stop}`, { responseType: 'blob' }));
	}

	printStatsFattorino(deliveryid: number, start: number, stop: number): Promise<any> {
		return this.mapResponse(this.http.get(`/ws/offer/stampa/statsfattorini/fattorino/${deliveryid}/${start}/${stop}`, { responseType: 'blob' }));
	}

	printBusta(id: number): Promise<any> {
		return this.mapResponse(this.http.get(`/ws/offer/stampa/busta/${id}`, { responseType: 'blob' }));
	}

	estemporanea(offer: Offer): Promise<Offer> {
		return this.mapResponse(this.http.post('/ws/offer/estemporanea', classToPlain(offer)), Offer);
	}

	emailTemplate(offerid: number): Promise<any> {
		return this.mapResponse(this.http.get(`/ws/offer/${offerid}/email`));
	}

	getRettifica(id: number): Promise<Rettifica> {
		return this.mapResponse(this.http.get(`/ws/offer/rettifica/${id}`), Rettifica);
	}

	saveRettifica(id: number, model: Rettifica): Promise<Rettifica> {
		return this.mapResponse(this.http.post(`/ws/offer/rettifica/${id}`, classToPlain(model)), Rettifica);
	}

	statsFattorino(deliveryid: number, start: number, stop: number): Promise<FattorinoStats[]> {
		return this.mapResponse(this.http.get(`/ws/offer/statsfattorini/fattorino/${deliveryid}/${start}/${stop}`), FattorinoStats);
	}

	annullaScarico(deliveryid: number, deliverydate: number): Promise<any> {
		return this.mapResponse(this.http.post(`/ws/offer/undodelivery/fattorino/${deliveryid}/${deliverydate}`, {}), FattorinoStats);
	}
}